// Initialize Cocoon for nested forms
document.addEventListener("turbolinks:load", function() {
  console.log("Initializing Cocoon event handlers");
  
  // Use namespaced events and unbind first to prevent duplicate handlers
  $(document).off('cocoon:after-insert.generic_handler').on('cocoon:after-insert.generic_handler', function(e, insertedItem) {
    console.log("Cocoon after insert event detected (generic handler)");
    // Skip selects that have custom AJAX handlers (part-select, labor-select, etc.)
    // These will be initialized by their specific form handlers with proper AJAX config
    $(insertedItem).find('select').not('.part-select, .labor-select, .technician-select, .location-select').each(function() {
      var $select = $(this);
      // Skip if already initialized
      if (!$select.hasClass('select2-hidden-accessible')) {
        $select.select2({
          width: '100%'
        });
      }
    });
  });

  // Add debug logging for Cocoon events (also namespaced to prevent duplicates)
  $(document).off('cocoon:before-insert.debug').on('cocoon:before-insert.debug', function() {
    console.log("Cocoon before insert event detected");
  });

  $(document).off('cocoon:after-remove.debug').on('cocoon:after-remove.debug', function() {
    console.log("Cocoon after remove event detected");
  });
}); 